import { Helmet } from "react-helmet";
import { RecipeFieldTypes } from "src/types/contentfulTypes";

interface RecipeMetaProps
  extends Pick<RecipeFieldTypes, "name" | "teaser" | "heroImage"> {}

const RecipeMeta = ({ name, teaser, heroImage }: RecipeMetaProps) => {
  return (
    <Helmet>
      <title>Recipe finder | {name}</title>
      <meta name="description" content={teaser ? teaser : ""} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`Recipe finder | ${name}`} />
      <meta property="og:description" content={teaser ? teaser : ""} />
      <meta property="og:image" content={heroImage ? heroImage.url : ""} />
      <meta property="og:url" content={window.location.href} />
      <meta name="twitter:title" content={`Recipe finder | ${name}`} />
      <meta name="twitter:description" content={teaser ? teaser : ""} />
      <meta name="twitter:image" content={heroImage ? heroImage.url : ""} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default RecipeMeta;
